<div class="container">
    <div class="row">
        <div class="col-xs-10 col-md-4">
            <div class="card">
                <h1>{{assetAddress}}</h1>
                <p class="lead">{{crmReference}}</p>
            </div>
        </div>
    </div>
</div>
